export default "images/banner.jpg";